module.exports = __webpack_public_path__ + "img/6-Z2T.d1efa01.jpg";